import { Button, Modal } from 'react-bootstrap'

//General Modals
export const InfoModal = ({ showInfoModal, setshowInfoModal }) => {
  return (
    <Modal show={showInfoModal} onHide={() => setshowInfoModal(false)} style={{ textAlign: 'center', direction: 'rtl' }} centered={true}>
      <Modal.Header>
        <div style={{ width: '100%' }}>
          <Modal.Title>שים לב!❤️</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>וודאו שכל הפריטים שהזמנתם אכן הגיעו.</div>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: 'center' }}>
        <Button
          variant='danger'
          onClick={() => {
            setshowInfoModal(false)
          }}
        >
          אישור
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export const ErrorModal = ({ showErrorModal, setshowErrorModal }) => {
  return (
    <Modal show={showErrorModal} onHide={() => setshowErrorModal(false)} style={{ direction: 'rtl' }}>
      <Modal.Header style={{ textAlign: 'right' }}>
        <div style={{ width: '100%' }}>
          <Modal.Title>שגיאה!</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>שגיאה בשליחת הבקשה. אנא פנה לשירות הלקוחות.</Modal.Body>
      <Modal.Footer>
        <Button variant='danger' onClick={() => setshowErrorModal(false)}>
          סגור
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export const ContentCheckModal = ({ showContentCheckModal, setsshowContentCheckModal, handleGoToUploadPage }) => {
  return (
    <Modal
      show={showContentCheckModal}
      onHide={() => setsshowContentCheckModal(false)}
      style={{ textAlign: 'center', direction: 'rtl' }}
      centered={true}
    >
      <Modal.Header>
        <div style={{ width: '100%' }}>
          <Modal.Title>שים לב!❤️</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>בדקת שכל הפריטים בהזמנה הגיעו?</div>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: 'center' }}>
        <Button variant='danger' onClick={handleGoToUploadPage}>
          כן! בואו נתקדם
        </Button>
        <Button
          variant='outline-info'
          onClick={() => {
            setsshowContentCheckModal(false)
          }}
        >
          לא בדקתי
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

//old modals
// // Package Requests Modals
// export const PhotoRequestModal = ({ showPhotoRequest, setshowPhotoRequest, handleReq }) => {
//   const [isLoading, setIsLoading] = useState(false)
//   const handleConfrim = async () => {
//     setIsLoading(true)
//     await handleReq('photoRequest')
//     setIsLoading(false)
//     setshowPhotoRequest(false)
//   }

//   return (
//     <Modal show={showPhotoRequest} onHide={() => setshowPhotoRequest(false)} style={{ textAlign: 'center', direction: 'rtl' }} centered={true}>
//       <Modal.Header>
//         <div style={{ width: '100%' }}>
//           <Modal.Title>צילום חבילה 📷</Modal.Title>
//         </div>
//       </Modal.Header>

//       {isLoading ? (
//         <div style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <>
//           <Modal.Body>
//             <div>
//               צילום החבילה כרוך בעמלה של 5$.
//               <br />
//               האם ברצונך להמשיך?
//             </div>
//           </Modal.Body>
//           <Modal.Footer style={{ justifyContent: 'center' }}>
//             <Button variant="danger" onClick={handleConfrim}>
//               כן{' '}
//             </Button>
//             <Button
//               variant="outline-info"
//               onClick={() => {
//                 setshowPhotoRequest(false)
//               }}
//             >
//               לא
//             </Button>
//           </Modal.Footer>
//         </>
//       )}
//     </Modal>
//   )
// }

// export const ReturnRequestModal = ({ showReturnRequest, setshowReturnRequest, handleReq }) => {
//   const [isLoading, setIsLoading] = useState(false)
//   const handleConfrim = async () => {
//     setIsLoading(true)
//     setIsLoading(false)
//     setshowReturnRequest(false)
//     await handleReq('returnRequest')
//   }

//   return (
//     <Modal show={showReturnRequest} onHide={() => setshowReturnRequest(false)} style={{ textAlign: 'center', direction: 'rtl' }} centered={true}>
//       <Modal.Header>
//         <div style={{ width: '100%' }}>
//           <Modal.Title>
//             החזרת חבילה <img src={returnPackageIcon} height="25px" />
//           </Modal.Title>
//         </div>
//       </Modal.Header>

//       {isLoading ? (
//         <div style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <>
//           <Modal.Body>
//             <div>
//               החזרת החבילה כרוכה בעמלה של 10$
//               <br />
//               וניתן לבטלה רק דרך פניה לשירות הלקוחות.
//               <br />
//               האם ברצונך להמשיך?
//             </div>
//           </Modal.Body>
//           <Modal.Footer style={{ justifyContent: 'center' }}>
//             <Button variant="danger" onClick={handleConfrim}>
//               כן{' '}
//             </Button>
//             <Button
//               variant="outline-info"
//               onClick={() => {
//                 setshowReturnRequest(false)
//               }}
//             >
//               לא
//             </Button>
//           </Modal.Footer>
//         </>
//       )}
//     </Modal>
//   )
// }

// export const ShrinkRequestModal = ({ showShrinkRequest, setshowShrinkRequest, handleReq }) => {
//   const [isLoading, setIsLoading] = useState(false)
//   const [tooltip, setTooltip] = useState('')
//   const [target, setTarget] = useState(null)
//   const [inputText, setinputText] = useState('')
//   const [charCount, setCharCount] = useState(0)
//   const charLimit = 200

//   const handleConfirm = async () => {
//     setIsLoading(true)
//     await handleReq('shrinkRequest', inputText)
//     setIsLoading(false)
//     setshowShrinkRequest(false)
//   }

//   const handleInput = (e) => {
//     let value = e.target.value
//     const invalidChars = /[^a-zA-Z0-9\s.,!?\-@#$%^&*()_+=\[\]{};:'"<>\/\\|`~]/g

//     if (invalidChars.test(value)) {
//       setTooltip('!אנגלית בלבד')
//       e.target.value = value.replace(invalidChars, '')
//       setTarget(e.target)
//       setTimeout(() => {
//         setTooltip('')
//         setTarget(null)
//       }, 2000)
//       return
//     }

//     // Enforce character limit
//     if (value.length > charLimit) {
//       value = value.slice(0, charLimit)
//     }

//     setinputText(value)
//     setCharCount(value.length)
//   }

//   return (
//     <Modal show={showShrinkRequest} onHide={() => setshowShrinkRequest(false)} style={{ textAlign: 'center', direction: 'rtl' }} centered={true}>
//       <Modal.Header>
//         <div style={{ width: '100%' }}>
//           <Modal.Title>
//             צמצום חבילה <img src={shrinkIcon} height="25px" alt="shrink icon" />
//           </Modal.Title>
//         </div>
//       </Modal.Header>

//       {isLoading ? (
//         <div style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <>
//           <Modal.Body>
//             <div>
//               צמצום החבילה כרוך בעמלה של 5$.
//               <br />
//               באפשרותך להוסיף הערות לבקשה כאן (באנגלית בלבד):
//               <br />
//               <div style={{ fontSize: '12px', marginTop: '5px' }}>
//                 {charCount}/{charLimit} תווים
//               </div>
//               <textarea style={{ width: '90%', direction: 'ltr', height: '140px' }} id="shrink-input" onInput={handleInput} value={inputText}></textarea>
//               <Overlay target={target} show={!!tooltip} placement="top">
//                 {(props) => (
//                   <Tooltip id="overlay-tooltip" {...props}>
//                     {tooltip}
//                   </Tooltip>
//                 )}
//               </Overlay>
//               <br />
//               האם ברצונך להמשיך?
//             </div>
//           </Modal.Body>
//           <Modal.Footer style={{ justifyContent: 'center' }}>
//             <Button variant="danger" onClick={handleConfirm}>
//               כן{' '}
//             </Button>
//             <Button
//               variant="outline-info"
//               onClick={() => {
//                 setshowShrinkRequest(false)
//               }}
//             >
//               לא
//             </Button>
//           </Modal.Footer>
//         </>
//       )}
//     </Modal>
//   )
// }

// //Package Requests Modals - Cancels
// export const CancelPhotoRequestModal = ({ showCancelPhotoRequest, setshowCancelPhotoRequest, handleCancelReq }) => {
//   const [isLoading, setIsLoading] = useState(false)
//   const handleConfrim = async () => {
//     setIsLoading(true)
//     await handleCancelReq('photoRequest')
//     setIsLoading(false)
//     setshowCancelPhotoRequest(false)
//   }

//   return (
//     <Modal show={showCancelPhotoRequest} onHide={() => setshowCancelPhotoRequest(false)} style={{ textAlign: 'center', direction: 'rtl' }} centered={true}>
//       <Modal.Header>
//         <div style={{ width: '100%' }}>
//           <Modal.Title> ביטול צילום חבילה 📷</Modal.Title>
//         </div>
//       </Modal.Header>

//       {isLoading ? (
//         <div style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <>
//           <Modal.Body>
//             <div>האם אתה בטוח שברצונך לבטל את צילום החבילה?</div>
//           </Modal.Body>
//           <Modal.Footer style={{ justifyContent: 'center' }}>
//             <Button variant="danger" onClick={handleConfrim}>
//               כן{' '}
//             </Button>
//             <Button
//               variant="outline-info"
//               onClick={() => {
//                 setshowCancelPhotoRequest(false)
//               }}
//             >
//               לא
//             </Button>
//           </Modal.Footer>
//         </>
//       )}
//     </Modal>
//   )
// }

// export const CancelShrinkRequestModal = ({ showCancelShrinkRequest, setshowCancelShrinkRequest, handleCancelReq }) => {
//   const [isLoading, setIsLoading] = useState(false)
//   const handleConfrim = async () => {
//     setIsLoading(true)
//     await handleCancelReq('shrinkRequest')
//     setIsLoading(false)
//     setshowCancelShrinkRequest(false)
//   }

//   return (
//     <Modal show={showCancelShrinkRequest} onHide={() => setshowCancelShrinkRequest(false)} style={{ textAlign: 'center', direction: 'rtl' }} centered={true}>
//       <Modal.Header>
//         <div style={{ width: '100%' }}>
//           <Modal.Title>
//             {' '}
//             ביטול צמצום חבילה <img src={shrinkIcon} height="25px" alt="shrink icon" />
//           </Modal.Title>
//         </div>
//       </Modal.Header>

//       {isLoading ? (
//         <div style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <>
//           <Modal.Body>
//             <div>האם אתה בטוח שברצונך לבטל את צמצום החבילה?</div>
//           </Modal.Body>
//           <Modal.Footer style={{ justifyContent: 'center' }}>
//             <Button variant="danger" onClick={handleConfrim}>
//               כן{' '}
//             </Button>
//             <Button
//               variant="outline-info"
//               onClick={() => {
//                 setshowCancelShrinkRequest(false)
//               }}
//             >
//               לא
//             </Button>
//           </Modal.Footer>
//         </>
//       )}
//     </Modal>
//   )
// }
